var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asset != null)?_c('div',[_c('options',{attrs:{"asset_id":_vm.asset.asset_id,"project_id":_vm.asset.project_id,"tab_index":_vm.tab_index},on:{"selectedApartment":_vm.selectedApartmentData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }